var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.18C2.5 19.83 4.67 22 8.31 22H16.68C20.32 22 22.49 19.83 22.49 16.19V7.81C22.5 4.17 20.33 2 16.69 2ZM10.63 14.5C10.92 14.79 10.92 15.27 10.63 15.56C10.48 15.71 10.29 15.78 10.1 15.78C9.91 15.78 9.72 15.71 9.57 15.56L7.08 13.07C6.49 12.48 6.49 11.53 7.08 10.94L9.57 8.45C9.86 8.16 10.34 8.16 10.63 8.45C10.92 8.74 10.92 9.22 10.63 9.51L8.14 12L10.63 14.5ZM17.92 13.06L15.43 15.55C15.28 15.7 15.09 15.77 14.9 15.77C14.71 15.77 14.52 15.7 14.37 15.55C14.08 15.26 14.08 14.78 14.37 14.49L16.86 12L14.37 9.5C14.08 9.21 14.08 8.73 14.37 8.44C14.66 8.15 15.14 8.15 15.43 8.44L17.92 10.93C18.51 11.52 18.51 12.48 17.92 13.06Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "97131/static/media/Code.d025cb5239e1013a72d01a7c9871f058.svg";
export { ForwardRef as ReactComponent };